import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPayoutDetails } from "../../services/firestoreService";


function PayoutPage() {
    const { payoutID } = useParams();
    const [payout, setPayout] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPayout = async () => {
            const payoutData = await getPayoutDetails(payoutID);
            setPayout(payoutData);
            setLoading(false);
        };

        fetchPayout();
    }, [payoutID]);

    if (loading) {
        return <div className="flex items-center justify-center h-screen text-gray-500 text-lg">Loading payout details...</div>;
    }

    return (
        <div className="p-6">
            <h1 className="text-3xl font-bold">Payout Details</h1>
            <p>Total Paid: €{payout.totalAmount.toFixed(2)}</p>
            <p>Date: {new Date(payout.createdAt.seconds * 1000).toLocaleString()}</p>

            <h2 className="text-2xl mt-4">Tips in this Payout</h2>
            {payout.tips.map((tip) => (
                <div key={tip.id} className="p-2 border rounded-lg mt-2">
                    <p>Amount: €{tip.amount}</p>
                    <p>Date: {new Date(tip.createdAt.seconds * 1000).toLocaleString()}</p>
                </div>
            ))}
        </div>
    );
}

export default PayoutPage;
